import { createStyles, makeStyles, TableCell, Theme, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import { TagGq } from '../../../../graphql/projects/models/TagGq';
import { TagGroupGq } from '../../../../graphql/projects/models/TagGroupGq';
import ColoredTagChip from '../KeywordTable/ColoredTagChip';

export interface TableCellTagGroupsProps {
  tagIds: number[];
  archived?: boolean;
  tagGroups: FastTagGroup[];
}

export interface FastTagGroup {
  tagGroup: TagGroupGq;
  tags: Record<number, TagGq>;
}

const useClasses = makeStyles((theme: Theme) =>
  createStyles({
    archivedCell: {
      color: theme.palette.grey[500],
    },
  })
);

const TableCellTagGroups: React.FC<TableCellTagGroupsProps> = React.memo(
  ({ tagIds, archived, tagGroups }) => {
    // Styling
    const theme = useTheme();
    const classes = useClasses(theme);

    return (
      <>
        {tagGroups.map((fastTagGroup) => {
          var tags = tagIds.map((tagId) => fastTagGroup.tags[tagId]).filter((tag) => !!tag);
          return (
            <TableCell
              key={fastTagGroup.tagGroup.id}
              padding={!!tags?.length ? 'checkbox' : 'normal'}
              align={'right'}
              className={clsx({
                [classes.archivedCell]: archived,
              })}
            >
              <div className="flex flex-row justify-center">
                {tags.map((tag) => (
                  <ColoredTagChip key={tag.id} tag={tag} tagGroup={fastTagGroup.tagGroup} />
                ))}
              </div>
            </TableCell>
          );
        })}
      </>
    );
  }
);

export default TableCellTagGroups;
